/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './rutas/__root'
import { Route as IndexRouteImport } from './rutas/index'
import { Route as AdministracionRouteImport } from './rutas/administracion'
import { Route as AjustesRouteImport } from './rutas/ajustes'
import { Route as BuscarRouteImport } from './rutas/buscar'
import { Route as EscribirRouteImport } from './rutas/escribir'
import { Route as ExplorarRouteImport } from './rutas/explorar'
import { Route as InvitacionesRouteImport } from './rutas/invitaciones'
import { Route as AdministracionIndexRouteImport } from './rutas/administracion.index'
import { Route as AdministracionCuponesRouteImport } from './rutas/administracion.cupones'
import { Route as AjustesIndexRouteImport } from './rutas/ajustes.index'
import { Route as AjustesAparienciaRouteImport } from './rutas/ajustes.apariencia'
import { Route as AjustesClavesRouteImport } from './rutas/ajustes.claves'
import { Route as AjustesPrivacidadRouteImport } from './rutas/ajustes.privacidad'
import { Route as BuscarIndexRouteImport } from './rutas/buscar.index'
import { Route as BuscarHistorialRouteImport } from './rutas/buscar.historial'
import { Route as BuscarVigilantesRouteImport } from './rutas/buscar.vigilantes'
import { Route as CompartidaIdRouteImport } from './rutas/compartida.$id'
import { Route as EscribirIndexRouteImport } from './rutas/escribir.index'
import { Route as EscribirCuadernosRouteImport } from './rutas/escribir.cuadernos'
import { Route as ExplorarIndexRouteImport } from './rutas/explorar.index'
import { Route as ExplorarConceptosRouteImport } from './rutas/explorar.conceptos'
import { Route as ExplorarCorpusRouteImport } from './rutas/explorar.corpus'
import { Route as ExplorarEntidadesRouteImport } from './rutas/explorar.entidades'
import { Route as ExplorarGrafoRouteImport } from './rutas/explorar.grafo'
import { Route as ExplorarPerspectivasRouteImport } from './rutas/explorar.perspectivas'
import { Route as LectorIdRouteImport } from './rutas/lector.$id'
import { Route as LotesIdRouteImport } from './rutas/lotes.$id'
import { Route as RecibirTokenRouteImport } from './rutas/recibir.$token'
import { Route as DocumentosIdContenidoRouteImport } from './rutas/documentos.$id.contenido'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministracionRoute = AdministracionRouteImport.update({
  id: '/administracion',
  path: '/administracion',
  getParentRoute: () => rootRouteImport,
} as any)
const AjustesRoute = AjustesRouteImport.update({
  id: '/ajustes',
  path: '/ajustes',
  getParentRoute: () => rootRouteImport,
} as any)
const BuscarRoute = BuscarRouteImport.update({
  id: '/buscar',
  path: '/buscar',
  getParentRoute: () => rootRouteImport,
} as any)
const EscribirRoute = EscribirRouteImport.update({
  id: '/escribir',
  path: '/escribir',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorarRoute = ExplorarRouteImport.update({
  id: '/explorar',
  path: '/explorar',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitacionesRoute = InvitacionesRouteImport.update({
  id: '/invitaciones',
  path: '/invitaciones',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministracionIndexRoute = AdministracionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdministracionRoute,
} as any)
const AdministracionCuponesRoute = AdministracionCuponesRouteImport.update({
  id: '/cupones',
  path: '/cupones',
  getParentRoute: () => AdministracionRoute,
} as any)
const AjustesIndexRoute = AjustesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AjustesRoute,
} as any)
const AjustesAparienciaRoute = AjustesAparienciaRouteImport.update({
  id: '/apariencia',
  path: '/apariencia',
  getParentRoute: () => AjustesRoute,
} as any)
const AjustesClavesRoute = AjustesClavesRouteImport.update({
  id: '/claves',
  path: '/claves',
  getParentRoute: () => AjustesRoute,
} as any)
const AjustesPrivacidadRoute = AjustesPrivacidadRouteImport.update({
  id: '/privacidad',
  path: '/privacidad',
  getParentRoute: () => AjustesRoute,
} as any)
const BuscarIndexRoute = BuscarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuscarRoute,
} as any)
const BuscarHistorialRoute = BuscarHistorialRouteImport.update({
  id: '/historial',
  path: '/historial',
  getParentRoute: () => BuscarRoute,
} as any)
const BuscarVigilantesRoute = BuscarVigilantesRouteImport.update({
  id: '/vigilantes',
  path: '/vigilantes',
  getParentRoute: () => BuscarRoute,
} as any)
const CompartidaIdRoute = CompartidaIdRouteImport.update({
  id: '/compartida/$id',
  path: '/compartida/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EscribirIndexRoute = EscribirIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EscribirRoute,
} as any)
const EscribirCuadernosRoute = EscribirCuadernosRouteImport.update({
  id: '/cuadernos',
  path: '/cuadernos',
  getParentRoute: () => EscribirRoute,
} as any)
const ExplorarIndexRoute = ExplorarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExplorarRoute,
} as any)
const ExplorarConceptosRoute = ExplorarConceptosRouteImport.update({
  id: '/conceptos',
  path: '/conceptos',
  getParentRoute: () => ExplorarRoute,
} as any)
const ExplorarCorpusRoute = ExplorarCorpusRouteImport.update({
  id: '/corpus',
  path: '/corpus',
  getParentRoute: () => ExplorarRoute,
} as any)
const ExplorarEntidadesRoute = ExplorarEntidadesRouteImport.update({
  id: '/entidades',
  path: '/entidades',
  getParentRoute: () => ExplorarRoute,
} as any)
const ExplorarGrafoRoute = ExplorarGrafoRouteImport.update({
  id: '/grafo',
  path: '/grafo',
  getParentRoute: () => ExplorarRoute,
} as any)
const ExplorarPerspectivasRoute = ExplorarPerspectivasRouteImport.update({
  id: '/perspectivas',
  path: '/perspectivas',
  getParentRoute: () => ExplorarRoute,
} as any)
const LectorIdRoute = LectorIdRouteImport.update({
  id: '/lector/$id',
  path: '/lector/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LotesIdRoute = LotesIdRouteImport.update({
  id: '/lotes/$id',
  path: '/lotes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RecibirTokenRoute = RecibirTokenRouteImport.update({
  id: '/recibir/$token',
  path: '/recibir/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentosIdContenidoRoute = DocumentosIdContenidoRouteImport.update({
  id: '/documentos/$id/contenido',
  path: '/documentos/$id/contenido',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/administracion': typeof AdministracionRouteWithChildren
  '/ajustes': typeof AjustesRouteWithChildren
  '/buscar': typeof BuscarRouteWithChildren
  '/escribir': typeof EscribirRouteWithChildren
  '/explorar': typeof ExplorarRouteWithChildren
  '/invitaciones': typeof InvitacionesRoute
  '/administracion/cupones': typeof AdministracionCuponesRoute
  '/ajustes/apariencia': typeof AjustesAparienciaRoute
  '/ajustes/claves': typeof AjustesClavesRoute
  '/ajustes/privacidad': typeof AjustesPrivacidadRoute
  '/buscar/historial': typeof BuscarHistorialRoute
  '/buscar/vigilantes': typeof BuscarVigilantesRoute
  '/compartida/$id': typeof CompartidaIdRoute
  '/escribir/cuadernos': typeof EscribirCuadernosRoute
  '/explorar/conceptos': typeof ExplorarConceptosRoute
  '/explorar/corpus': typeof ExplorarCorpusRoute
  '/explorar/entidades': typeof ExplorarEntidadesRoute
  '/explorar/grafo': typeof ExplorarGrafoRoute
  '/explorar/perspectivas': typeof ExplorarPerspectivasRoute
  '/lector/$id': typeof LectorIdRoute
  '/lotes/$id': typeof LotesIdRoute
  '/recibir/$token': typeof RecibirTokenRoute
  '/administracion/': typeof AdministracionIndexRoute
  '/ajustes/': typeof AjustesIndexRoute
  '/buscar/': typeof BuscarIndexRoute
  '/escribir/': typeof EscribirIndexRoute
  '/explorar/': typeof ExplorarIndexRoute
  '/documentos/$id/contenido': typeof DocumentosIdContenidoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invitaciones': typeof InvitacionesRoute
  '/administracion/cupones': typeof AdministracionCuponesRoute
  '/ajustes/apariencia': typeof AjustesAparienciaRoute
  '/ajustes/claves': typeof AjustesClavesRoute
  '/ajustes/privacidad': typeof AjustesPrivacidadRoute
  '/buscar/historial': typeof BuscarHistorialRoute
  '/buscar/vigilantes': typeof BuscarVigilantesRoute
  '/compartida/$id': typeof CompartidaIdRoute
  '/escribir/cuadernos': typeof EscribirCuadernosRoute
  '/explorar/conceptos': typeof ExplorarConceptosRoute
  '/explorar/corpus': typeof ExplorarCorpusRoute
  '/explorar/entidades': typeof ExplorarEntidadesRoute
  '/explorar/grafo': typeof ExplorarGrafoRoute
  '/explorar/perspectivas': typeof ExplorarPerspectivasRoute
  '/lector/$id': typeof LectorIdRoute
  '/lotes/$id': typeof LotesIdRoute
  '/recibir/$token': typeof RecibirTokenRoute
  '/administracion': typeof AdministracionIndexRoute
  '/ajustes': typeof AjustesIndexRoute
  '/buscar': typeof BuscarIndexRoute
  '/escribir': typeof EscribirIndexRoute
  '/explorar': typeof ExplorarIndexRoute
  '/documentos/$id/contenido': typeof DocumentosIdContenidoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/administracion': typeof AdministracionRouteWithChildren
  '/ajustes': typeof AjustesRouteWithChildren
  '/buscar': typeof BuscarRouteWithChildren
  '/escribir': typeof EscribirRouteWithChildren
  '/explorar': typeof ExplorarRouteWithChildren
  '/invitaciones': typeof InvitacionesRoute
  '/administracion/cupones': typeof AdministracionCuponesRoute
  '/ajustes/apariencia': typeof AjustesAparienciaRoute
  '/ajustes/claves': typeof AjustesClavesRoute
  '/ajustes/privacidad': typeof AjustesPrivacidadRoute
  '/buscar/historial': typeof BuscarHistorialRoute
  '/buscar/vigilantes': typeof BuscarVigilantesRoute
  '/compartida/$id': typeof CompartidaIdRoute
  '/escribir/cuadernos': typeof EscribirCuadernosRoute
  '/explorar/conceptos': typeof ExplorarConceptosRoute
  '/explorar/corpus': typeof ExplorarCorpusRoute
  '/explorar/entidades': typeof ExplorarEntidadesRoute
  '/explorar/grafo': typeof ExplorarGrafoRoute
  '/explorar/perspectivas': typeof ExplorarPerspectivasRoute
  '/lector/$id': typeof LectorIdRoute
  '/lotes/$id': typeof LotesIdRoute
  '/recibir/$token': typeof RecibirTokenRoute
  '/administracion/': typeof AdministracionIndexRoute
  '/ajustes/': typeof AjustesIndexRoute
  '/buscar/': typeof BuscarIndexRoute
  '/escribir/': typeof EscribirIndexRoute
  '/explorar/': typeof ExplorarIndexRoute
  '/documentos/$id/contenido': typeof DocumentosIdContenidoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/administracion'
    | '/ajustes'
    | '/buscar'
    | '/escribir'
    | '/explorar'
    | '/invitaciones'
    | '/administracion/cupones'
    | '/ajustes/apariencia'
    | '/ajustes/claves'
    | '/ajustes/privacidad'
    | '/buscar/historial'
    | '/buscar/vigilantes'
    | '/compartida/$id'
    | '/escribir/cuadernos'
    | '/explorar/conceptos'
    | '/explorar/corpus'
    | '/explorar/entidades'
    | '/explorar/grafo'
    | '/explorar/perspectivas'
    | '/lector/$id'
    | '/lotes/$id'
    | '/recibir/$token'
    | '/administracion/'
    | '/ajustes/'
    | '/buscar/'
    | '/escribir/'
    | '/explorar/'
    | '/documentos/$id/contenido'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invitaciones'
    | '/administracion/cupones'
    | '/ajustes/apariencia'
    | '/ajustes/claves'
    | '/ajustes/privacidad'
    | '/buscar/historial'
    | '/buscar/vigilantes'
    | '/compartida/$id'
    | '/escribir/cuadernos'
    | '/explorar/conceptos'
    | '/explorar/corpus'
    | '/explorar/entidades'
    | '/explorar/grafo'
    | '/explorar/perspectivas'
    | '/lector/$id'
    | '/lotes/$id'
    | '/recibir/$token'
    | '/administracion'
    | '/ajustes'
    | '/buscar'
    | '/escribir'
    | '/explorar'
    | '/documentos/$id/contenido'
  id:
    | '__root__'
    | '/'
    | '/administracion'
    | '/ajustes'
    | '/buscar'
    | '/escribir'
    | '/explorar'
    | '/invitaciones'
    | '/administracion/cupones'
    | '/ajustes/apariencia'
    | '/ajustes/claves'
    | '/ajustes/privacidad'
    | '/buscar/historial'
    | '/buscar/vigilantes'
    | '/compartida/$id'
    | '/escribir/cuadernos'
    | '/explorar/conceptos'
    | '/explorar/corpus'
    | '/explorar/entidades'
    | '/explorar/grafo'
    | '/explorar/perspectivas'
    | '/lector/$id'
    | '/lotes/$id'
    | '/recibir/$token'
    | '/administracion/'
    | '/ajustes/'
    | '/buscar/'
    | '/escribir/'
    | '/explorar/'
    | '/documentos/$id/contenido'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdministracionRoute: typeof AdministracionRouteWithChildren
  AjustesRoute: typeof AjustesRouteWithChildren
  BuscarRoute: typeof BuscarRouteWithChildren
  EscribirRoute: typeof EscribirRouteWithChildren
  ExplorarRoute: typeof ExplorarRouteWithChildren
  InvitacionesRoute: typeof InvitacionesRoute
  CompartidaIdRoute: typeof CompartidaIdRoute
  LectorIdRoute: typeof LectorIdRoute
  LotesIdRoute: typeof LotesIdRoute
  RecibirTokenRoute: typeof RecibirTokenRoute
  DocumentosIdContenidoRoute: typeof DocumentosIdContenidoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracion': {
      id: '/administracion'
      path: '/administracion'
      fullPath: '/administracion'
      preLoaderRoute: typeof AdministracionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ajustes': {
      id: '/ajustes'
      path: '/ajustes'
      fullPath: '/ajustes'
      preLoaderRoute: typeof AjustesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buscar': {
      id: '/buscar'
      path: '/buscar'
      fullPath: '/buscar'
      preLoaderRoute: typeof BuscarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/escribir': {
      id: '/escribir'
      path: '/escribir'
      fullPath: '/escribir'
      preLoaderRoute: typeof EscribirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorar': {
      id: '/explorar'
      path: '/explorar'
      fullPath: '/explorar'
      preLoaderRoute: typeof ExplorarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitaciones': {
      id: '/invitaciones'
      path: '/invitaciones'
      fullPath: '/invitaciones'
      preLoaderRoute: typeof InvitacionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracion/': {
      id: '/administracion/'
      path: '/'
      fullPath: '/administracion/'
      preLoaderRoute: typeof AdministracionIndexRouteImport
      parentRoute: typeof AdministracionRoute
    }
    '/administracion/cupones': {
      id: '/administracion/cupones'
      path: '/cupones'
      fullPath: '/administracion/cupones'
      preLoaderRoute: typeof AdministracionCuponesRouteImport
      parentRoute: typeof AdministracionRoute
    }
    '/ajustes/': {
      id: '/ajustes/'
      path: '/'
      fullPath: '/ajustes/'
      preLoaderRoute: typeof AjustesIndexRouteImport
      parentRoute: typeof AjustesRoute
    }
    '/ajustes/apariencia': {
      id: '/ajustes/apariencia'
      path: '/apariencia'
      fullPath: '/ajustes/apariencia'
      preLoaderRoute: typeof AjustesAparienciaRouteImport
      parentRoute: typeof AjustesRoute
    }
    '/ajustes/claves': {
      id: '/ajustes/claves'
      path: '/claves'
      fullPath: '/ajustes/claves'
      preLoaderRoute: typeof AjustesClavesRouteImport
      parentRoute: typeof AjustesRoute
    }
    '/ajustes/privacidad': {
      id: '/ajustes/privacidad'
      path: '/privacidad'
      fullPath: '/ajustes/privacidad'
      preLoaderRoute: typeof AjustesPrivacidadRouteImport
      parentRoute: typeof AjustesRoute
    }
    '/buscar/': {
      id: '/buscar/'
      path: '/'
      fullPath: '/buscar/'
      preLoaderRoute: typeof BuscarIndexRouteImport
      parentRoute: typeof BuscarRoute
    }
    '/buscar/historial': {
      id: '/buscar/historial'
      path: '/historial'
      fullPath: '/buscar/historial'
      preLoaderRoute: typeof BuscarHistorialRouteImport
      parentRoute: typeof BuscarRoute
    }
    '/buscar/vigilantes': {
      id: '/buscar/vigilantes'
      path: '/vigilantes'
      fullPath: '/buscar/vigilantes'
      preLoaderRoute: typeof BuscarVigilantesRouteImport
      parentRoute: typeof BuscarRoute
    }
    '/compartida/$id': {
      id: '/compartida/$id'
      path: '/compartida/$id'
      fullPath: '/compartida/$id'
      preLoaderRoute: typeof CompartidaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/escribir/': {
      id: '/escribir/'
      path: '/'
      fullPath: '/escribir/'
      preLoaderRoute: typeof EscribirIndexRouteImport
      parentRoute: typeof EscribirRoute
    }
    '/escribir/cuadernos': {
      id: '/escribir/cuadernos'
      path: '/cuadernos'
      fullPath: '/escribir/cuadernos'
      preLoaderRoute: typeof EscribirCuadernosRouteImport
      parentRoute: typeof EscribirRoute
    }
    '/explorar/': {
      id: '/explorar/'
      path: '/'
      fullPath: '/explorar/'
      preLoaderRoute: typeof ExplorarIndexRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/explorar/conceptos': {
      id: '/explorar/conceptos'
      path: '/conceptos'
      fullPath: '/explorar/conceptos'
      preLoaderRoute: typeof ExplorarConceptosRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/explorar/corpus': {
      id: '/explorar/corpus'
      path: '/corpus'
      fullPath: '/explorar/corpus'
      preLoaderRoute: typeof ExplorarCorpusRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/explorar/entidades': {
      id: '/explorar/entidades'
      path: '/entidades'
      fullPath: '/explorar/entidades'
      preLoaderRoute: typeof ExplorarEntidadesRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/explorar/grafo': {
      id: '/explorar/grafo'
      path: '/grafo'
      fullPath: '/explorar/grafo'
      preLoaderRoute: typeof ExplorarGrafoRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/explorar/perspectivas': {
      id: '/explorar/perspectivas'
      path: '/perspectivas'
      fullPath: '/explorar/perspectivas'
      preLoaderRoute: typeof ExplorarPerspectivasRouteImport
      parentRoute: typeof ExplorarRoute
    }
    '/lector/$id': {
      id: '/lector/$id'
      path: '/lector/$id'
      fullPath: '/lector/$id'
      preLoaderRoute: typeof LectorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lotes/$id': {
      id: '/lotes/$id'
      path: '/lotes/$id'
      fullPath: '/lotes/$id'
      preLoaderRoute: typeof LotesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recibir/$token': {
      id: '/recibir/$token'
      path: '/recibir/$token'
      fullPath: '/recibir/$token'
      preLoaderRoute: typeof RecibirTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentos/$id/contenido': {
      id: '/documentos/$id/contenido'
      path: '/documentos/$id/contenido'
      fullPath: '/documentos/$id/contenido'
      preLoaderRoute: typeof DocumentosIdContenidoRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdministracionRouteChildren {
  AdministracionCuponesRoute: typeof AdministracionCuponesRoute
  AdministracionIndexRoute: typeof AdministracionIndexRoute
}

const AdministracionRouteChildren: AdministracionRouteChildren = {
  AdministracionCuponesRoute: AdministracionCuponesRoute,
  AdministracionIndexRoute: AdministracionIndexRoute,
}

const AdministracionRouteWithChildren = AdministracionRoute._addFileChildren(
  AdministracionRouteChildren,
)

interface AjustesRouteChildren {
  AjustesAparienciaRoute: typeof AjustesAparienciaRoute
  AjustesClavesRoute: typeof AjustesClavesRoute
  AjustesPrivacidadRoute: typeof AjustesPrivacidadRoute
  AjustesIndexRoute: typeof AjustesIndexRoute
}

const AjustesRouteChildren: AjustesRouteChildren = {
  AjustesAparienciaRoute: AjustesAparienciaRoute,
  AjustesClavesRoute: AjustesClavesRoute,
  AjustesPrivacidadRoute: AjustesPrivacidadRoute,
  AjustesIndexRoute: AjustesIndexRoute,
}

const AjustesRouteWithChildren =
  AjustesRoute._addFileChildren(AjustesRouteChildren)

interface BuscarRouteChildren {
  BuscarHistorialRoute: typeof BuscarHistorialRoute
  BuscarVigilantesRoute: typeof BuscarVigilantesRoute
  BuscarIndexRoute: typeof BuscarIndexRoute
}

const BuscarRouteChildren: BuscarRouteChildren = {
  BuscarHistorialRoute: BuscarHistorialRoute,
  BuscarVigilantesRoute: BuscarVigilantesRoute,
  BuscarIndexRoute: BuscarIndexRoute,
}

const BuscarRouteWithChildren =
  BuscarRoute._addFileChildren(BuscarRouteChildren)

interface EscribirRouteChildren {
  EscribirCuadernosRoute: typeof EscribirCuadernosRoute
  EscribirIndexRoute: typeof EscribirIndexRoute
}

const EscribirRouteChildren: EscribirRouteChildren = {
  EscribirCuadernosRoute: EscribirCuadernosRoute,
  EscribirIndexRoute: EscribirIndexRoute,
}

const EscribirRouteWithChildren = EscribirRoute._addFileChildren(
  EscribirRouteChildren,
)

interface ExplorarRouteChildren {
  ExplorarConceptosRoute: typeof ExplorarConceptosRoute
  ExplorarCorpusRoute: typeof ExplorarCorpusRoute
  ExplorarEntidadesRoute: typeof ExplorarEntidadesRoute
  ExplorarGrafoRoute: typeof ExplorarGrafoRoute
  ExplorarPerspectivasRoute: typeof ExplorarPerspectivasRoute
  ExplorarIndexRoute: typeof ExplorarIndexRoute
}

const ExplorarRouteChildren: ExplorarRouteChildren = {
  ExplorarConceptosRoute: ExplorarConceptosRoute,
  ExplorarCorpusRoute: ExplorarCorpusRoute,
  ExplorarEntidadesRoute: ExplorarEntidadesRoute,
  ExplorarGrafoRoute: ExplorarGrafoRoute,
  ExplorarPerspectivasRoute: ExplorarPerspectivasRoute,
  ExplorarIndexRoute: ExplorarIndexRoute,
}

const ExplorarRouteWithChildren = ExplorarRoute._addFileChildren(
  ExplorarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdministracionRoute: AdministracionRouteWithChildren,
  AjustesRoute: AjustesRouteWithChildren,
  BuscarRoute: BuscarRouteWithChildren,
  EscribirRoute: EscribirRouteWithChildren,
  ExplorarRoute: ExplorarRouteWithChildren,
  InvitacionesRoute: InvitacionesRoute,
  CompartidaIdRoute: CompartidaIdRoute,
  LectorIdRoute: LectorIdRoute,
  LotesIdRoute: LotesIdRoute,
  RecibirTokenRoute: RecibirTokenRoute,
  DocumentosIdContenidoRoute: DocumentosIdContenidoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
